import { ElementConverter } from "@api/repositories/types/ElementConverter";
import {ElementInterface} from "@api/models/interfaces/ElementInterface";
import {WebConferencesRecordings} from "@api/models/WebConferencesRecordings";
import { Tag } from "../Tag";
import { TagInterface } from "../interfaces/TagInterface";
import { AgendaModel } from "../agenda/AgendaModel";
import { ExhibitionModel } from "../exhibition/ExhibitionModel";
import { Event } from "@api/models/Event";
import { CommitteeModel } from "../committees/CommitteeModel";

export const webConferenceRecordingConverter: ElementConverter = (item: ElementInterface, schema: string) => {
    return new WebConferencesRecordings(item, schema);
}

export const participantsTagsConverter: ElementConverter = (item: ElementInterface, schema: string) => {
    return new Tag(item as TagInterface, schema)
}

export const agendaConverter: ElementConverter = (item: ElementInterface, schema: string) => {
    return new AgendaModel(item, schema);
}

//@todo come up with idea how to make it more simple
export const eventConverter: ElementConverter = (item: ElementInterface, schema: string) => {
    return new Event(item, schema);
}

export const exhibitionConverter: ElementConverter = (item: ElementInterface, schema: string) => {
    return new ExhibitionModel(item, schema);
}

export const committeeConverter: ElementConverter = (item: ElementInterface, schema: string) => {
    return new CommitteeModel(item, schema);
}

export const companyConverter: ElementConverter<ElementInterface> = (item: ElementInterface) => {
    item.title = item.parentId.title ? `${item.title} (${item.parentId.title})` : item.title;
    return item;
}

export const rawConverter: ElementConverter<ElementInterface> = (item: ElementInterface) => {
    return item
}
